import axios from '../../plugins/axios.js';

export default {
  async getPartners() {
    return await axios.get('api/Partner');
  },
  async getPartnerStatuses() {
    return await axios.get('api/Partner/PartnerStatus');
  },
  async getPartnerByID(partnerID) {
    return await axios.get(`/api/Partner/${partnerID}`);
  },
  async createPartner(partner) {
    return await  axios.post('/api/Partner', partner);
  },
  async updatePartner(partner) {
    return await axios.put('/api/Partner', partner);
  },
  async getState() {
    return await axios.get('/api/USStates');
  },
  async archivePartner(partnerValues) {
    return await axios.post('/api/Partner/ArchivePartner', partnerValues);
  },   
  async getPartnerEntities() {
    return await axios.get('/api/Partner/GetPartnerEntities');
  }
};
